export const formatAppName = (appName: string) => appName.replace(/\//g, ' › ');
